import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Helmet } from "react-helmet";
import { withRouter } from 'react-router-dom';

import {
  TabContent,
  TabPane,
} from 'reactstrap';

import { connect } from 'react-redux';

import {
  getVoucherList,
  getSingleVoucher,
  getVoucherCompanies,
  getVoucherCategories,
} from '../../../actions/customer';

import { loginAppUser, getAppUserData } from '../../../actions/user'; 

import DashboardInfoBox from './Components/DashboardInfoBox2';
import HomepageTopInfoCards from './Components/HomepageTopInfoCards';
import PopularVouchers from './PopularVouchers';
import HowItWorks from './HowItWorks';
import AllVouchers from './AllVouchers';
import AsSeenIn from './AsSeenIn';

const pound = `${'\u00A3'}`;

class VouchersList extends Component {
  static propTypes = {
    user: PropTypes.shape(),
    admin: PropTypes.shape(),
    getVouchers: PropTypes.func.isRequired,
  };

  static defaultProps = {
    user: {},
    admin: {},
  };

  constructor(props) {
    super(props);
    this.state = {
      error: null,
      loading: false,
      enabled: false,
      deleteSettingModal: false,
      deleteSettingErr: null,
      settingToDelete: null,
      activeTab: '1',
      activeTabPopularVouhers: 2,
      companyNotification: '',
      allChecked: true,
      checked: {},
      companyNotifications: [],
      companyInformation: '',
      selectedStep: 1,
      purchaseModal: false,
      showPassword1: 'password',
      activeCategory: null,
    };

    this.allVouchersRef = React.createRef();
  }

  componentDidMount() {
    const { user } = this.props;
  }

  changeActiveCategory = (id) => {
    if (id === 'all') {
      this.setState({ activeCategory: 'all' });
    } else {
      this.setState({ activeCategory: id });
    }
  }

  handleChange = e => this.setState({ [e.target.name]: e.target.value });

  toggleShowPassword = (id) => {
    if (id === 1) {
      this.setState({
        showPassword1: this.state.showPassword1 === 'input' ? 'password' : 'input'
      })
    } else if (id === 2) {
      this.setState({
        showPassword2: this.state.showPassword2 === 'input' ? 'password' : 'input'
      })
    }
  }

  scrollToAllVouchers = () => {
    if (this.allVouchersRef && this.allVouchersRef.current) {
      this.allVouchersRef.current.scrollIntoView();
    }
  }

  setActiveTabPopularVouhers = (tab) => {
    const { lastScroll } = this.state;
    this.setState({ activeTabPopularVouhers: tab, tabChangedPopularVouhers: true });

    const doc = document.getElementById("featuredVouchersSection");

    if (doc) {
      doc.scrollIntoView();
    }

    /*
    setTimeout(() => {
      if (lastScroll === 'down') {
        window.scrollBy(0, -1);
        this.setState({ lastScroll: 'up' });
      } else {
        window.scrollBy(0, 1);
        this.setState({ lastScroll: 'down' });
      }
    }, 50); */
  }

  scrollToTop = () => {
    console.log('scrollToTop');
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }

  render() {
    const { vouchersList, orderedVouchers } = this.props;
    const {
      activeTab,
      activeCategory,
      activeTabPopularVouhers,
      tabChangedPopularVouhers,
    } = this.state;

    let vouchersFiltered = vouchersList;

    let voucherPurchasedLevels = {};

    Object.keys(orderedVouchers).map((key) => {
      if (orderedVouchers[key].voucher && orderedVouchers[key].voucher.id) {
        const voucherId = orderedVouchers[key].voucher.id;
        if (voucherPurchasedLevels[voucherId]) {
          if (voucherPurchasedLevels[voucherId][orderedVouchers[key].voucherStep]) {
            voucherPurchasedLevels[voucherId][orderedVouchers[key].voucherStep][orderedVouchers[key].voucherId] = true;
          } else {
            voucherPurchasedLevels[voucherId][orderedVouchers[key].voucherStep] = { [orderedVouchers[key].voucherId]: true };
          }
        } else {
          voucherPurchasedLevels[voucherId] = {
            [orderedVouchers[key].voucherStep]: { [orderedVouchers[key].voucherId]: true },
          };
        }
      }
    });

    let finishedCampaigns = {};

    Object.keys(voucherPurchasedLevels).map((key) => {
      if (voucherPurchasedLevels[key] && voucherPurchasedLevels[key][1] && voucherPurchasedLevels[key][1][2] && voucherPurchasedLevels[key][2] && voucherPurchasedLevels[key][2][2] && voucherPurchasedLevels[key][3] && voucherPurchasedLevels[key][3][2]) {

        finishedCampaigns[key] = voucherPurchasedLevels[key];
      }
    });

    if (finishedCampaigns && Object.keys(finishedCampaigns).length) {
      let newVouchersFiltered = {};
      Object.keys(vouchersFiltered).map((key) => {
        if (vouchersList[key] && !finishedCampaigns[key]) {
          newVouchersFiltered[key] = vouchersList[key];
        }
      });
      vouchersFiltered = newVouchersFiltered;
    }

    if (!vouchersList) {
      return (
        <div className="preloader">
          <div className="preloader-inner">
            <div className="preloader-icon">
              <span></span>
              <span></span>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div>
        <Helmet>
          <meta name="description" content="Discover exclusive vouchers from independent businesses. Save money and support local with increasing discounts on repeat purchases." />
        </Helmet>
        <TabContent activeTab={activeTab}>
          <TabPane tabId="1">
            <div>
              <DashboardInfoBox vouchersList={vouchersList} setActiveTabPopularVouhers={this.setActiveTabPopularVouhers} scrollToAllVouchers={this.scrollToAllVouchers} />

              <HomepageTopInfoCards setActiveTabPopularVouhers={this.setActiveTabPopularVouhers} scrollToTop={this.scrollToTop} />

              <PopularVouchers vouchersList={vouchersFiltered} scrollToAllVouchers={this.scrollToAllVouchers} activeTab={activeTabPopularVouhers} tabChanged={tabChangedPopularVouhers} setActiveTab={this.setActiveTabPopularVouhers} />

              <HowItWorks />
              <AsSeenIn />

              <div ref={this.allVouchersRef} style={{ height: 0, position: 'relative', top: 150 }}></div>
              <AllVouchers vouchersList={vouchersFiltered} changeActiveCategory={this.changeActiveCategory} activeCategory={activeCategory} scrollToAllVouchers={this.scrollToAllVouchers} />
            </div>
          </TabPane>
        </TabContent>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user.userData || {},
  vouchersList: state.customer.list || {},
  orderedVouchers: state.customer.orderedVouchers || {},
});

const mapDispatchToProps = {
  getVouchers: getVoucherList,
  fetchSingleVoucher: getSingleVoucher,
  fetchVoucherCompanies: getVoucherCompanies,
  fetchVoucherCategories: getVoucherCategories,
  login: loginAppUser,
  fetchUserData: getAppUserData,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(VouchersList));